export const VIEW_IDEAS = 'VIEW_IDEAS';
export const ADD_IDEAS = 'ADD_IDEAS';
export const UPDATE_IDEA = 'UPDATE_IDEA';
export const UPDATE_IDEA_STATUS = 'UPDATE_IDEA_STATUS';
export const DELETE_IDEA = 'DELETE_IDEA';
export const SELECTED_IDEA = 'SELECTED_IDEA';
